import EventsHelper from '../../_helpers/events';

export default class MatchStatusLoader {

  matchStatus = {
    DEFAULT: -1,
    SCHEDULED: 0,
    LIVE: 1,
    FINISHED: 2,
  }
  currentStatus = this.matchStatus.DEFAULT;
  statusContent = '';

  constructor() {
    let _this = this;

    if (!window.matchconfig) { return; }

    EventsHelper.OnBeforeMatchDay(function () {
      _this.currentStatus = _this.matchStatus.DEFAULT;
      _this.setStatus(_this.matchStatus.SCHEDULED);
    });

    EventsHelper.OnAfterMatchDay(function () {
      _this.currentStatus = _this.matchStatus.DEFAULT;
      _this.setStatus(_this.matchStatus.FINISHED);
    });

    EventsHelper.On('MatchDataUpdate', function (data) {
      if (data.detail) {
        let status = data.detail.status;
        _this.setStatus(status);
      }

    });


  }

  setStatus(newStatus) {
    let _this = this;

    if (newStatus !== this.matchStatus.SCHEDULED &&
      newStatus !== this.matchStatus.LIVE &&
      newStatus !== this.matchStatus.FINISHED) { return; }

    if (newStatus !== _this.currentStatus) {
      _this.currentStatus = newStatus;
      _this.loadStatusContent();
    }
  }

  getStatusLibrary() {
    let _this = this;
    let statusLib = '';

    switch (this.currentStatus) {
      case _this.matchStatus.SCHEDULED:
        statusLib = window.matchconfig.statuscontent.scheduled;
        break;
      case _this.matchStatus.LIVE:
        statusLib = window.matchconfig.statuscontent.live;
        break;
      case _this.matchStatus.FINISHED:
        statusLib = window.matchconfig.statuscontent.finished;
        break;
    }

    statusLib = statusLib.replace('{no}', window.matchconfig.match);

    return statusLib;
  }

  loadStatusContent() {
    let _this = this;

    let $statusContent = $('.status-content');
    let statusLibrary = _this.getStatusLibrary();

    if ($statusContent.length && statusLibrary) {
      $statusContent.load(statusLibrary, function () {
        EventsHelper.AjaxModuleLoaded();
      });
    }
  }

}

